/**
 * Platform detection utilities for Capacitor iOS wrapper
 * Web users continue with existing flows (Stripe, web OAuth)
 * Native users use StoreKit (RevenueCat) and native auth
 */

import { Capacitor } from '@capacitor/core';

// Log platform detection on module load
console.log('[iOS-DEBUG] 📱 Platform module loaded');
console.log('[iOS-DEBUG] Platform:', Capacitor.getPlatform());
console.log('[iOS-DEBUG] isNativePlatform:', Capacitor.isNativePlatform());

/**
 * Check if running in native iOS/Android app
 * @returns {boolean} true if native, false if web browser
 */
export const isNativePlatform = () => {
  return Capacitor.isNativePlatform();
};

/**
 * Check if running specifically on iOS
 * @returns {boolean} true if iOS native app
 */
export const isIOS = () => {
  return Capacitor.getPlatform() === 'ios';
};

/**
 * Check if running specifically on Android
 * @returns {boolean} true if Android native app
 */
export const isAndroid = () => {
  return Capacitor.getPlatform() === 'android';
};

/**
 * Check if running in web browser
 * @returns {boolean} true if web browser
 */
export const isWeb = () => {
  return Capacitor.getPlatform() === 'web';
};

/**
 * Get current platform name
 * @returns {'ios' | 'android' | 'web'} platform identifier
 */
export const getPlatform = () => {
  return Capacitor.getPlatform();
};

/**
 * Check if a native plugin is available
 * @param {string} pluginName - Name of the plugin to check
 * @returns {boolean} true if plugin is available
 */
export const isPluginAvailable = (pluginName) => {
  return Capacitor.isPluginAvailable(pluginName);
};
